/**
 * Avalara © 2020
 * file: engines/opus_ui/src/containers/SecureRoutesContainer.jsx
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import config from '../config';
import { getBaseUrlFromConfig } from '../utils/url_helpers';
import loadingGif from '../assets/loading.gif';

const baseUrl = getBaseUrlFromConfig(config.biztechApi);

const AUTHORIZATION_STATUS = {
  AUTHORIZED: 200,
  UNAUTHORIZED: 403,
  INTERNAL_SERVER_ERROR: 500,
  LOADING: 300
};

class SecureRoutesContainer extends Component {
  constructor() {
    super();

    this.state = { authStatus: AUTHORIZATION_STATUS.LOADING, roles: [] };
  }

  componentDidMount() {
    this.authorize();
  }

  authorize = async () => {
    // const headers = { Authorization: `Bearer ${this.props.auth.token}` };

    return await axios
      .get(`${baseUrl}/default/isAuthorized/${this.props.page}`)
      .catch(error => {
        return {
          status: error.response.status,
          roles: error.response.data.data
        };
      })
      .then(result => {
        return this.setState({
          authStatus: result.status,
          roles: result.roles ? result.roles : []
        });
      });
  };

  render() {
    switch (this.state.authStatus) {
      case AUTHORIZATION_STATUS.AUTHORIZED:
        return this.props.children;

      case AUTHORIZATION_STATUS.UNAUTHORIZED:
        return (
          <div>
            <h1>Access Denied </h1>
            {this.state.roles.length > 0 && (
              <h3>
                You must be part of OPUS-Authorized-User Group. Please contact
                OPUS oncall support.
              </h3>
            )}
          </div>
        );

      case AUTHORIZATION_STATUS.LOADING:
        return (
          <div>
            {' '}
            <br />
            <br /> <br /> <img src={loadingGif} alt="Please wait" />{' '}
            <h1>processing ...</h1>{' '}
          </div>
        );

      default:
        return (
          <div>
            <h1>Something went wrong </h1>
            <h3>Please try again later</h3>{' '}
          </div>
        );
    }
  }
}

export default connect(({ auth }) => ({ auth }))(SecureRoutesContainer);
